import { apiClient } from '@/lib/api/client'

export interface ProfilePayload {
  id?: number
  user_login?: string
  user_email?: string
  contact_number?: string
  first_name?: string
  last_name?: string
  nickname?: string
  biography?: string
  attachment_file?: string
  theme?: string
  user_pass?: string
}

export interface ProfileResponse<T = any> {
  success?: boolean
  message?: string
  data?: T
}

export const ProfileService = {
  async getMe(): Promise<ProfileResponse> {
    const res = await apiClient.post('/user/me')
    return res.data
  },
  async updateProfile(payload: ProfilePayload): Promise<ProfileResponse> {
    const res = await apiClient.post('/profile', payload)
    return res.data
  },
}

